import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

/**
 * Cart-specific quantity selector.
 * The base component dispatches QuantitySelectorUpdateEvent with data-cart-line,
 * and component-cart-items.js owns the Ajax cart update + section morph.
 */
export class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  getEffectiveMax() {
    const { max } = this.getCurrentValues();
    return max;
  }
}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define('cart-quantity-selector-component', CartQuantitySelectorComponent);
}
